import { TableCell } from '@mui/material'
import { styled } from '@mui/material/styles'
import { colorPalette } from '../../../../style/colorPalette'

export const TableHeaderCell = styled(TableCell)({
  fontSize: '14px',
  fontWeight: 'bold',
  color: colorPalette.monotone[10],
  padding: '10px 16px',
  backgroundColor: colorPalette.monotone[1],
  position: 'sticky',
  top: 0,
  zIndex: 1,
})

export const TableDataCell = styled(TableCell)({
  fontSize: '14px',
  color: colorPalette.monotone[10],
  padding: '10px 16px',
})
